import configs from "../../configs.js";

export const AUTH_TOKEN_COOKIE_BASE_NAME = "auth_token";
export const AUTH_HINT_COOKIE_BASE_NAME = "auth_hint";

const SAFE_COOKIE_PREFIX_PATTERN = /^[A-Za-z0-9_-]+$/;

function normalizeAuthCookiePrefix(value) {
  if (typeof value !== "string") {
    return "";
  }

  const trimmed = value.trim().replace(/^_+|_+$/g, "");
  return SAFE_COOKIE_PREFIX_PATTERN.test(trimmed) ? trimmed : "";
}

function buildAuthCookieName(baseName) {
  const prefix = normalizeAuthCookiePrefix(configs.AUTH_COOKIE_PREFIX);
  return prefix ? `${prefix}_${baseName}` : baseName;
}

export function getAuthTokenCookieName() {
  return buildAuthCookieName(AUTH_TOKEN_COOKIE_BASE_NAME);
}

export function getAuthHintCookieName() {
  return buildAuthCookieName(AUTH_HINT_COOKIE_BASE_NAME);
}

export function getAuthTokenCookieNameCandidates() {
  return [getAuthTokenCookieName()];
}
